var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfettiTriangles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 129.001,
    height: 130.142,
    viewBox: "0 0 129.001 130.142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 8",
    d: "M97.6118 88.3219L115.788 73.7379L121.539 92.5087L97.6118 88.3219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 9",
    d: "M21.5865 36.3652L4.32494 19.0347L20.3229 12.8953L21.5865 36.3652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 10",
    d: "M63.4796 38.1909L58.357 9.27699L78.6046 13.3184L63.4796 38.1909Z",
    fill: "#00FEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 11",
    d: "M98.9833 54.1004L103.722 43.0745L110.782 50.0664L98.9833 54.1004Z",
    fill: "#00FEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 12",
    d: "M83.1518 117.575L102.077 113.456L99.7484 127.973L83.1518 117.575Z",
    fill: "#00FEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiTriangles);
export default __webpack_public_path__ + "static/media/confetti-triangles.f15a67cbf906d1400589204fd2954c24.svg";
export { ForwardRef as ReactComponent };